//hooks
import { useState, useEffect, use } from "react"
import { useApi } from "../../../hooks/useApi"
import { useRef } from "react";

//api
import { GetAvailableCarsApi } from "../../../api/Cars/GetAvailableCarsApi";

//component
import AvailableCarsFilter from "../../../component/filter/AvailableCarsFilter";
import CarCard from "../../../component/carCard/CarCard";
import CarDetails from "../../../popup/carDetails/CarDetails";

//mui
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import { DialogProps } from '@mui/material/Dialog';


//mui icon
import ReplayIcon from '@mui/icons-material/Replay';
import FilterListAltIcon from '@mui/icons-material/FilterListAlt';

//tranlsate
import { useTranslation } from "react-i18next";

//type
import { carType } from "../../../api/Cars/type/CarsType";


const AvailableCars = () => {
  const {t} = useTranslation();
  const [availableCarsData, setAvailableCarsData] = useState<carType[]>([]);
  const [page, setPage] = useState<number>(1);
  const carsPerPage = 8;
  const [lastPage, setLastPage] = useState<number>(1);
  const [initialLoading, setInitialLoading] = useState<boolean>(true);
  const [initialError, setInitialError] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const loaderRef = useRef<HTMLDivElement | null>(null);
  const [selectedCar, setSelectedCar] = useState<carType | null>(null);
  const [openCarDetails, setOpenCarDetails] = useState<{open:boolean,scrollType: DialogProps['scroll']}>({
    open:false,
    scrollType: "paper",
  });

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const {
    loading: availableCarLoading,
    error: availableCarError,
    HandlerApi: getAvailableCars
  } = useApi(GetAvailableCarsApi, "GET");

  const handleResizeForWidth = () => {
    if (window.innerWidth >= 900 && open) {
      setOpen(false);
    }
  };
  
  useEffect(() => {
    window.addEventListener("resize", handleResizeForWidth);
    return () => {
      window.removeEventListener("resize", handleResizeForWidth);
    }
  }, [open]);

  useEffect(() => {
    const fetchData = async (page: number) => {
      try {
        const resultBestCars = await getAvailableCars({page: page, per_page: carsPerPage});
        setLastPage(resultBestCars.data.last_page);
        setAvailableCarsData((prev: any) => {
          const newCars = resultBestCars.data.data;
          const filteredPrev = prev.filter((car:any) => !newCars.some((element:any) => element.id === car.id));
          const combined = [...filteredPrev, ...newCars];
          return combined;
        });
        setInitialLoading(false);
        setInitialError(false);
      }
      catch (error) {
        setInitialLoading(false);
        if (page === 1) {
          setInitialError(true);
        }
        else {
          setInitialError(false);
        }
      }
      finally {
        setInitialLoading(false);
      }
    };
      fetchData(page);
  }, [page]);
  
  useEffect(() => {
    if (!loaderRef.current){
      return;
    }
    else {
      // It watches an element and tells you:“Is this element visible on the screen right now?”
      const observer = new IntersectionObserver((entries) => {
        const firstEntry = entries[0];
        if (
            firstEntry.isIntersecting &&
            !availableCarLoading &&
            page < lastPage &&
            !availableCarError
          ) {
            setPage((prev) => prev + 1);
          }
        });
      //tells the Intersection Observer:“Watch this element”
      observer.observe(loaderRef.current);
      return () => {
        observer.disconnect(); // تنظيف مهم جدًا
      };
    }
  }, [availableCarLoading]); 
  
  //start functions

  const fetchDataToReplay = async (page: number) => {
    if(page === 1) {
      setInitialLoading(true)
    }
    try {
      const resultBestCars = await getAvailableCars({page: page, per_page: carsPerPage});
      setLastPage(resultBestCars.data.last_page);
      setAvailableCarsData((prev: any) => {
        const newCars = resultBestCars.data.data;
        const filteredPrev = prev.filter((car:any) => !newCars.some((element:any) => element.id === car.id));
        const combined = [...filteredPrev, ...newCars];
        return combined;
      });
      setInitialLoading(false);
      setInitialError(false);
    }
    catch (error) {
      setInitialLoading(false);
      if (page === 1) {
        setInitialError(true);
      }
    }
    finally {
      setInitialLoading(false);
    }
  };

  //end functions

  return (
    <Box>
      <Box>
        <Toolbar className="justify-between">
          <Typography variant="h6" component="div">
            {t("avilable_cars")}
          </Typography>
          <Button onClick={toggleDrawer(true)} sx={{display: {md: "none", xs: "block"}}} className="!bg-customerColor !rounded-[10px] !text-white">
            <FilterListAltIcon />
          </Button >
        </Toolbar>
        <Drawer
        sx={{
          '.MuiDrawer-paper': {
            width: 270,
            boxSizing: 'border-box',
            padding: "10px",
          },
        }}
        open={open} 
        onClose={toggleDrawer(false)}
        >
          <AvailableCarsFilter 
          setAvailableCarsData={setAvailableCarsData} 
          page={page} 
          setPage={setPage} 
          setInitialLoading={setInitialLoading} 
          />
        </Drawer>
      </Box>
      <Box sx={{ display: 'flex', gap: "20px"}}>
        <Box sx={{ width: "30%", 
          display: {md: "block", xs: "none"}, 
          borderRadius: "10px", 
          boxShadow: "0 30px 30px rgba(0,0,0,0.1)", 
          border: "1px solid #e5e5e5",
          position: "sticky",
          top: "120px",
          height: "760px",
          overflow: "auto"
        }}
        >
          <AvailableCarsFilter 
          setAvailableCarsData={setAvailableCarsData} 
          page={page} 
          setPage={setPage} 
          setInitialLoading={setInitialLoading} 
          />
        </Box>
        <Box sx={{width: "100%"}}>
          <Box>
            <div>
              {initialLoading
              ?
                <div className='flex justify-center'>
                  <CircularProgress/>
                </div>
              :
              <div>
                  {initialError // availableCarError
                  ?
                    <div className='cursor-pointer flex justify-center'>
                      <ReplayIcon onClick={()=>{
                        setAvailableCarsData([])
                        fetchDataToReplay(page)
                        }} className='!text-[40px]'/>
                    </div>
                  : 
                  availableCarsData.length !== 0
                    ?
                    <>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(270px, 1fr))", gap: "20px" }}>
                        {
                          availableCarsData.map((element, index) => (
                            <div className='cursor-pointer'
                            key={index}
                            onClick={() => {setOpenCarDetails({open: true, scrollType: "paper"}); setSelectedCar(element)}}
                            >
                              <CarCard key={index} element={element}/>
                            </div>
                          ))
                        }
                      </div>
                      {page < lastPage && <div ref={loaderRef} style={{ height: "10px" }} />}
                      {availableCarLoading && (
                        <div className="flex justify-center mt-4">
                          <CircularProgress size={32}/>
                        </div>
                      )}
                      {availableCarError && (
                        <div className=" cursor-pointer flex justify-center mt-4">
                          <ReplayIcon onClick={()=>{
                            fetchDataToReplay(page)
                            }} className='!text-[40px]'/>
                        </div>
                      )}
                    </>
                    :<p className='flex justify-center items-center'>{t("no_cars")}</p>
                }
              </div>
              }
            </div>
            {selectedCar && (
              <CarDetails
                selectedCar={selectedCar}
                setSelectedCar={setSelectedCar}
                openCarDetails={openCarDetails}
                setOpenCarDetails={setOpenCarDetails}
              />
            )} 
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default AvailableCars